var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43214"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 107",
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "#FFC5CC",
    stroke: "#F3223C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 10.5H16M10.5 5V16",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon2);
export default __webpack_public_path__ + "static/media/plusIcon (2).c8f043f5a38e7dbe74fcccbfa574ac35.svg";
export { ForwardRef as ReactComponent };